import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { buildChartPalette, chartAxisColors } from '../utils/chartTheme';

export default function useAnalyticsChartPalette(overrideColors = []) {
  const theme = useTheme();

  return useMemo(() => {
    const colors = overrideColors.length
      ? overrideColors
      : buildChartPalette(theme);
    const axis = chartAxisColors(theme);
    const primary = colors[0] || theme.palette.primary.main;
    const barLabelColor = theme.palette.getContrastText(primary);

    return {
      colors,
      primary,
      barLabelColor,
      axis,
    };
  }, [overrideColors, theme]);
}
